import React, { useState, useCallback } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  Aggregation, AggregationInterval, ArgumentAxis,
  Label, TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import {SIFReportingCompanies, SIFFilter, SIFMap} from '../'
//import { groupBy } from '../../utils/miscUtil';

export default function SIFActualVsPotential(props) {
  const [data, setData] = useState();

  const calculateCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }
    var fd1 = {
      'DATE OF EVENT (m/d/yyyy)': aggregationInfo.intervalStart,
      Potential: 0,
      Actual: 0,
    }
    console.log(aggregationInfo.data);
    var potCnt = 0;
    var actCnt = 0;
    for (var i=0; i<aggregationInfo.data.length; i++) {
      if ((parseInt(aggregationInfo.data[i]['Number of Fatalities']) || 0)+(parseInt(aggregationInfo.data[i]['Number of Serious Injuries']) || 0)) {
        actCnt++;
      } else {
        potCnt++;
      }
    }
    fd1.Potential = potCnt;
    fd1.Actual = actCnt;
    return fd1;
  }, []);

  function customizeText(arg) {
    console.log(arg);
    let q = Math.floor((arg.value.getMonth() + 3) / 3).toString();
    let y = arg.value.getFullYear().toString();
    return `Qtr ${q} ${y}`;
  }

  const onFilterDataChanged = useCallback((data) => {
    setData([...data]);
  }, []);

  const customizeTooltip = useCallback((pointInfo) => {
    console.log(pointInfo);
    let q = Math.floor((pointInfo.argument.getMonth() + 3) / 3).toString();
    let y = pointInfo.argument.getFullYear().toString();
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${`Qtr ${q} ${y}`} - Events: ${pointInfo.total}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].valueText} (${pointInfo.points[i].percentText})</div>`
      }
      txt=txt+`</div></div>`
    }
    return {
      html: txt,
    }
  }, []);

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={true}
        showDisciplines={true}
        showActivities={true}
        showPrimaryFactor={true}
        showCategories={true}
      />
      <SIFMap
        accentColorRGB={'237, 78, 32,'}
        data={props.data.filter(item => ((parseInt(item['Number of Fatalities']) || 0)+(parseInt(item['Number of Serious Injuries']) || 0)>0))}
        title={"Actual Events by Basin"}
      />
      <SIFMap
        accentColorRGB={'0, 162, 200,'}
        data={props.data.filter(item => ((parseInt(item['Number of Fatalities']) || 0)+(parseInt(item['Number of Serious Injuries']) || 0)===0))}
        title={"Potential Events by Basin"}
      />
      <Chart
        id="chart"
        dataSource={data}
        title={'Actual vs Potential Events ('+data?.length.toString()+')'}
      >
        <ArgumentAxis aggregatedPointsPosition="crossTicks">
          <AggregationInterval quarters={1} />
          <TickInterval quarters={1} />
          <Label customizeText={customizeText}
          />
        </ArgumentAxis>
        <CommonSeriesSettings
          argumentField="DATE OF EVENT (m/d/yyyy)"
          type="stackedbar"
        >
          <Aggregation
            enabled={true}
            calculate={calculateCount}
            method="custom"
          />
        </CommonSeriesSettings>
        <Series
          valueField="Potential"
          name="Potential"
          color="#144c6d"
        >
        </Series>
        <Series
          valueField="Actual"
          name="Actual"
          color="#ec5020"
        >
        </Series>
        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
      <SIFReportingCompanies data={data}/>

    </div>
  );
}
